import { pageBuilderService } from "@/services/api";
import { groupByArrayOfObject } from '@/common/arrays'

const initialStates = {
    status: "LOADING",
    pagesList: {},
};

const mutations = {
    loading(state) {
        state.status = "LOADING";
    },
    createPages(state, page) {
        state.status = "CREATE";
        state.pagesList = Object.assign({ [page.id]: page }, state.pagesList);
    },
    setPagesList(state, pages) {
        state.status = 'SET_LIST'
        state.pagesList = pages
    },
    updatePage(state, page) {
        state.status = 'UPDATE'
        state.pagesList[page.id] = Object.assign({}, state.pagesList[page.id], page)
    },
    deletePage(state, id) {
        state.status = 'DELETE_FROM_LIST'
        delete state.pagesList[id]
    },
};

const getters = {
    pages: (state) => state.pagesList,
    pageBySlug: (state, getters) => slug => {
        return Object.values(getters.pages).filter(item => {
            if (item.slug === slug) {
                return item
            }
        })
    }
};

const actions = {
    fetch({ commit }) {
        commit("loading");

        return new Promise((resolve, reject) => {
            pageBuilderService.fetch()
                .then((response) => {
                    const result = response.data;
                    const pages = groupByArrayOfObject(result.data, 'id')

                    commit("setPagesList", pages);
                    resolve(result);
                })
                .catch((error) => {
                    commit("error");
                    reject(error.response ? error.response.data : error.response);
                });
        });
    },
    create({ commit }, params) {
        commit("loading");

        return new Promise((resolve, reject) => {
            pageBuilderService.create(params)
                .then((response) => {
                    const result = response.data;
                    commit("createPages", result.data);
                    resolve(result);
                })
                .catch((error) => {
                    commit("error");
                    reject(error.response ? error.response.data : error.response);
                });
        });
    },
    edit({ commit }, params) {
        commit('loading')

        return new Promise((resolve, reject) => {
            pageBuilderService.edit(params, params.id)
                .then(() => {
                    commit('updatePage', params)
                    resolve()
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    delete({ commit }, hashid) {
        commit('loading')

        return new Promise((resolve, reject) => {
            pageBuilderService.delete(hashid)
                .then(() => {
                    commit('deletePage', hashid)
                    resolve()
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
};

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
};
